/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：800__part-1
 */

"use strict"

import * as /* [auto-meaningful-name] */ReactDom from /* 80 */"react-dom"
import /* [auto-meaningful-name] */ReactDom1 from /* 80 */"react-dom"
function p(e) {
  return e instanceof HTMLElement ? e : ReactDom1.findDOMNode(e)
}
export { p }
